import { toTypedSchema } from "@vee-validate/zod";
import { z } from "zod";

import { i18n } from "@/i18n";

const { t } = i18n.global;

const ArticleFeedback = z.object({
  name: z
    .string({ required_error: t("validation.required") })
    .max(255, { message: t("validation.max", { max: 255 }) })
    .min(1, { message: t("validation.required") }),
  email: z
    .string({ required_error: t("validation.required") })
    .max(255, { message: t("validation.max", { max: 255 }) })
    .min(1, { message: t("validation.required") })
    .email(t("validation.email")),
  feedback: z.string({ required_error: t("validation.required") }).min(1, { message: t("validation.required") }),
  canContact: z.literal<boolean>(true),

  dictionaryId: z.string(),
  dictionaryTitle: z.string(),
  methodId: z.string(),
  url: z.string(),

  query: z.string().nullable(),
  lemma: z.string().nullable(),
  wordclass: z.string().nullable()
});

export type ArticleFeedback = z.infer<typeof ArticleFeedback>;

export const articleFeedbackFormValidator = toTypedSchema(ArticleFeedback);
